import React, { useEffect, useRef, useState } from 'react';
import bem from 'utils/bem';
import Icon from 'components/Icon';
import Text from 'components/Text';
import { Skeleton } from '@mui/material';
import './index.sass';

//todo replace when merge with sberjazz
const Info = ({children}) => (
    <div className={ 'info' }>
        <Icon name={ 'info' } />
        <Text>{ children }</Text>
    </div>
)

const { block, el } = bem('cdek-widget-container');
const CDEKWidgetContainer = ({ showWidget, address, cdekLoadStatus }) => {
    const nodeRef  = useRef(null);
    const [width, setWidth] = useState('auto');
    const [height, setHeight] = useState('auto');
    const preventDefaultHandler = (e) => {
        e.preventDefault();
    }

    useEffect(() => {
        if (cdekLoadStatus !== 'loaded') { return; }
        if (nodeRef.current) {
            const cb = (entries) => {
                const entry = entries[0];
                if (entry.contentRect) {
                    setWidth(entry.contentRect.width === 0 ? '100%' : `${entry.contentRect.width}px`);
                    setHeight(entry.contentRect.height === 0 ? '100%' : `${entry.contentRect.height}px`);
                }
            }
            const resizeObserver = new ResizeObserver(cb);
            resizeObserver.observe(nodeRef.current);
            return () => resizeObserver.disconnect();
        }
    }, [cdekLoadStatus, nodeRef]);

    if (showWidget && cdekLoadStatus === 'pending') {
        return <>
            <Info>Выбор доставки с помощью виджета СДЭК может работать медленно. Пожалуйста, не закрывайте страницу</Info>
            <CDEKWidgetContainerSkeleton />
        </>
    }

    if (showWidget && cdekLoadStatus === 'failed') {
        return <Text>Произошла ошибка при загрузке виджета. Пожалуйста, перезагрузите страницу, или свяжитесь с нашими менеджерами</Text>
    }

    return (
        <>
            { showWidget && <Info>Выбор доставки с помощью виджета СДЭК может работать медленно. Пожалуйста, не закрывайте страницу</Info> }
            <div className={ block() } ref={ nodeRef }>
            <div className={ el('stretch-container', { 'show': showWidget }) }>
                    <div id='forpvz' style={ { width, height } } className={ el('forpvz') }
                         onClick={ preventDefaultHandler } />
                </div>
                { address !== '' && <div className={ el('delivery-address') }>
                    <Icon name={ 'map-pin' } />
                    <div className={ el('delivery-address-content') }>
                        <div className={ el('delivery-address-label') }>
                            <Text>Адрес доставки</Text>
                        </div>
                        <div className={ el('delivery-address-value') }>
                            <Text>{ address }</Text>
                        </div>
                    </div>
                </div> }
            </div>
        </>
    )
}

export default CDEKWidgetContainer;

const CDEKWidgetContainerSkeleton = () => {
    return <Skeleton width={ '100%' } variant={ 'rounded' }>
        <div style={ { paddingTop: '54%' } } />
    </Skeleton>
}
